import React, { useEffect, useState } from 'react';
import Content from '../../../layout/content/Content';
import Head from '../../../layout/head/Head';
import { useNavigate, useParams } from 'react-router';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Icon, Row } from '../../../components/Component';
import PageHeading from '../components/page_heading/PageHeading';
import { Card, DropdownItem, DropdownMenu, DropdownToggle, Spinner, UncontrolledDropdown } from 'reactstrap';
import { employee_dashboard_actions_helper } from '../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { RETRIEVE_SPECIFIC_USER_DETAILS_API } from '../../../api/api_data';
import { fail_specific_user_details, loading_specific_user_details, reset_specific_user_details, success_specific_user_details } from '../../../reducers/dashboard_reducers/user/specific_user_details_Slice';
import { RETRIEVE_USER_DETAILS_ACCESS_DENIED_MSG, RETRIEVE_USER_DETAILS_ERR_MSG, RETRIEVE_USER_DETAILS_SUCCESS_MSG } from '../../../constants/success_error_messages_consts';
import { findUpper, messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import * as app_consts from "../../../constants/react_app_consts";
import CardTabs from '../components/cards/CardTabs';
import ProfileDetailText from '../components/text/ProfileDetailText';
import moment from 'moment';
import ImageContainer from '../../../components/partials/gallery/GalleryImage';
import ReadOnlyTable from '../components/table/ReadOnlyTable';
import { FaInfoCircle } from 'react-icons/fa';
import UserDetailsModal from '../components/modal/user_details_modal/UserDetailsModal';
import { Link } from 'react-router-dom';
import { findModuleAction } from '../../../utils/functionalUtils';
import AuthLoader from '../../components/page_messaging/AuthLoader';
import AuthError from '../../components/page_messaging/AuthError';
import EditUserMainDetailsModal from '../components/modal/EditUserMainDetailsModal';

const type = app_consts.USER_ACCOUNT_LIST;
const page_type = app_consts.USER_DETAILS;
const initial_actions_data = { onboard_user: false, assign_customer: false };

const UserDetails = () => {

    const { phone_number } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [page_data, setPageData] = useState([]);
    const dispatch = useDispatch();
    const [activeCardTab, setActiveCardTab] = useState("Main Details");
    const [dataFetched, setDataFetched] = useState(false);
    const [user_account_list, setUserAccountList] = useState([]);
    const [componentData, setComponentData] = useState(initial_actions_data);
    const [isUserModelOpen, setUserModelOpen] = useState(false);
    const [user_det_modal_type, setUserDetModalType] = useState("");
    const [sm, updateSm] = useState(false);
    const [account_actions, setAccountActions] = useState([]);
    const [edit_main_details_modal, setEditMainDetailsModal] = useState(false);
    const navigate = useNavigate();

    const open_edit_main_details_modal = () => {
        setEditMainDetailsModal(true);
    };

    const close_edit_main_details_modal = () => {
        setEditMainDetailsModal(false);
    };

    // UseEffect that Runs When Page first Opends
    useEffect(() => {
        retrieve_user_details();
        if (localStorage.getItem("log_cred"))
        {
            setAccountActions(JSON.parse(localStorage.getItem('log_cred'))?.user_actions);
        }
    }, []);

    // Listen to Changes In Account Actions
    useEffect(() => {
        if (account_actions)
        {
            let actions_data = initial_actions_data;
            account_actions?.map((module) => {
                if (module.module_name === app_consts.ONBOARDING) 
                {
                    // Actions Data
                    if (findModuleAction(app_consts.ONBOARD_COMPANY, module))
                    {
                        actions_data.create_loading_order = true;
                    }
                }
            });
            setComponentData(actions_data);
        }
    }, [account_actions]);

    const retrieve_user_details = () => {
        dispatch(
            employee_dashboard_actions_helper(
                loading_specific_user_details,
                success_specific_user_details,
                fail_specific_user_details,
                RETRIEVE_USER_DETAILS_ERR_MSG,
                RETRIEVE_USER_DETAILS_SUCCESS_MSG,
                app_consts.POST,
                RETRIEVE_SPECIFIC_USER_DETAILS_API,
                { phone_number: phone_number },
                RETRIEVE_USER_DETAILS_ACCESS_DENIED_MSG
            )
        );
    };

    // Listen to Reducer State
    const specific_user_details = useSelector((state) => state.specific_user_details.specific_user_details);
    // 
    useEffect(() => {
        if (specific_user_details.status !== app_consts.IDLE)
        {
            if (specific_user_details.status === app_consts.LOADING)
            {
                setError("");
                setLoading(true);
            } else
            {
                setLoading(false);
                if (specific_user_details.status === app_consts.FAIL)
                {
                    setError(specific_user_details.message);
                    messageToast(specific_user_details.message, app_consts.FAIL);
                } else if (specific_user_details.status === app_consts.SUCCESS)
                {
                    setPageData(specific_user_details.data);
                    setUserAccountList(specific_user_details.data?.user_accounts);
                }
                dispatch(reset_specific_user_details());
            }
        }
    }, [specific_user_details]);

    // Card Tabs
    const tabs = [
        {
            tabName: "Main Details", custom_icon: <FaInfoCircle style={{ fontSize: '16px', marginRight: 5 }} />
        },
        {
            tabName: "User Accounts", icon: "user-circle"
        },
    ];

    // Retrieve Module Actions Data
    const action_roles = useSelector((state) => state.auth_routes.auth_routes);
    // UseEffect to Place Page Data
    useEffect(() => {
        if (action_roles.status === app_consts.SUCCESS)
        {
            if (action_roles.data.system_management)
            {
                setComponentData(action_roles.data.system_management.module_actions);
            }
        }
    }, [action_roles]);

    const assign_user_action = () => {
        setUserModelOpen(true);
        setUserDetModalType(app_consts.ADD_USER_ACCOUNT_MODAL);
    };

    const edit_user_details_successfunction = (user_number) => {
        navigate(`/dashboard/user/${user_number}`);
        dispatch(
            employee_dashboard_actions_helper(
                loading_specific_user_details,
                success_specific_user_details,
                fail_specific_user_details,
                RETRIEVE_USER_DETAILS_ERR_MSG,
                RETRIEVE_USER_DETAILS_SUCCESS_MSG,
                app_consts.POST,
                RETRIEVE_SPECIFIC_USER_DETAILS_API,
                { phone_number: user_number },
                RETRIEVE_USER_DETAILS_ACCESS_DENIED_MSG
            )
        );
    };

    return (
        <>
            <Head title={`User Details - ${phone_number}`} />
            <Content>
                <BlockHead size="sm">
                    <BlockBetween className="g-3">
                        <BlockHeadContent>
                            <BlockTitle page>{`User Details - ${phone_number}`}</BlockTitle>
                            <BlockDes className="text-soft my-2 ">
                                <p>User Details, KYC Information and Transaction Information</p>
                            </BlockDes>
                            <Link to={`/dashboard/user`}>
                                <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                                    <Icon name="arrow-left"></Icon>
                                    <span>Back</span>
                                </Button>
                            </Link>
                            <Link to={`/dashboard/user`}>
                                <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
                                    <Icon name="arrow-left"></Icon>
                                </Button>
                            </Link>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            {
                                !loading && (
                                    <>
                                        <div className="toggle-wrap nk-block-tools-toggle">
                                            <Button
                                                className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                                                onClick={() => updateSm(!sm)}
                                            >
                                                <Icon name="menu-alt-r"></Icon>
                                            </Button>
                                            <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                                                <ul className="nk-block-tools g-3">
                                                    <li className="preview-item">
                                                        <UncontrolledDropdown>
                                                            <div className="btn-group">
                                                                <DropdownToggle color="light" outline className="dropdown-toggle-split btn-white">
                                                                    <Icon name="chevron-down"></Icon>

                                                                    <span>Actions</span>
                                                                </DropdownToggle>
                                                            </div>
                                                            <DropdownMenu className="mt-3">
                                                                <ul className="link-list-opt"> {
                                                                    ((findModuleAction(app_consts.ASSIGN_CUSTOMER, componentData) !== null) || findModuleAction(app_consts.ONBOARD_COMPANY, componentData) !== null) && (
                                                                        <>
                                                                            <li style={{ cursor: "pointer" }}>
                                                                                <DropdownItem
                                                                                    tag="a"
                                                                                    className='cursor'
                                                                                    onClick={(ev) => {
                                                                                        ev.preventDefault();
                                                                                        assign_user_action();
                                                                                    }}
                                                                                >
                                                                                    <span>Add User Account</span>
                                                                                </DropdownItem>
                                                                            </li>
                                                                        </>
                                                                    )}
                                                                    {findModuleAction(app_consts.ONBOARD_COMPANY, componentData) !== null && (
                                                                        <>
                                                                            <li>
                                                                                <DropdownItem
                                                                                    tag="a"
                                                                                    href="#"
                                                                                    onClick={(ev) => {
                                                                                        ev.preventDefault();
                                                                                        open_edit_main_details_modal();
                                                                                    }}
                                                                                >
                                                                                    <span>Edit User Details</span>
                                                                                </DropdownItem>
                                                                            </li>
                                                                        </>
                                                                    )
                                                                    }
                                                                </ul>
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>

                <Block>
                    <Card>
                        <div className="card-aside-wrap" id="user-detail-block">
                            <div className="card-content">
                                <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} dataFetched={setDataFetched} />
                                {
                                    loading ?
                                        <>
                                            <AuthLoader loading_message="Loading User Details..." />
                                        </>
                                        :
                                        <>
                                            {
                                                error && error.length > 0 ?
                                                    <>
                                                        <AuthError error_message={error} />
                                                    </>
                                                    :
                                                    <>
                                                        <div className="card-inner">
                                                            {
                                                                activeCardTab === "Main Details" && (
                                                                    <>
                                                                        <Block>
                                                                            <BlockHead>
                                                                                <BlockTitle tag="h5">Main Details</BlockTitle>
                                                                                <p>Names, Address and Contact Information</p>
                                                                            </BlockHead>
                                                                            <BlockHead>
                                                                                <BlockTitle tag="h6">Names and Contact Information</BlockTitle>
                                                                            </BlockHead>
                                                                            <div className="profile-ud-list">
                                                                                <ProfileDetailText label="First Name" text={page_data?.first_name || "---"} />
                                                                                <ProfileDetailText label="Middle Name" text={page_data?.middle_name || "---"} />
                                                                                <ProfileDetailText label="Surname" text={page_data?.surname || "---"} />
                                                                                <ProfileDetailText label="Email Address" text={page_data?.email_address || "---"} />
                                                                                <ProfileDetailText label="Phone Number" text={page_data?.phone_number || "---"} />
                                                                                <ProfileDetailText textClassName={page_data.account_status_id === 1
                                                                                    ? "text-success" : "text-warning"} label="Account Status" text={page_data?.account_status || "---"} />
                                                                                <ProfileDetailText textClassName={page_data?.kyc_registration_status_id === 1 ? "text-success" : "text-warning"} label="KYC Status" text={page_data?.kyc_registration_status || "---"} />
                                                                                <ProfileDetailText label="Registration Date" text={page_data?.registration_date ? moment(page_data?.registration_date).format("MMMM Do, YYYY h:mm:ss") : "---"} />
                                                                            </div>
                                                                            <BlockHead className='mt-5'>
                                                                                <BlockTitle tag="h6">Address Information</BlockTitle>
                                                                            </BlockHead>
                                                                            <div className="profile-ud-list">
                                                                                <ProfileDetailText label="Physical Address" text={page_data?.address || "---"} />
                                                                                <ProfileDetailText label="District" text={page_data?.district || "---"} />
                                                                                <ProfileDetailText label="Country" text={page_data?.country || "---"} />
                                                                            </div>
                                                                            <BlockHead className='mt-5'>
                                                                                <BlockTitle tag="h6">Registered Branch</BlockTitle>
                                                                            </BlockHead>
                                                                            <div className="profile-ud-list">
                                                                                <ProfileDetailText label="Branch Area" text={page_data?.branch_area || "---"} />
                                                                                <ProfileDetailText label="Branch Physical Address" text={page_data?.branch_physical_address || "---"} />
                                                                                <ProfileDetailText label="Province" text={page_data?.branch_province_name || "---"} />
                                                                                <ProfileDetailText label="Country" text={page_data?.branch_country_name || "---"} />
                                                                            </div>

                                                                            <BlockHead className='mt-5'>
                                                                                <BlockTitle tag="h6">Document Information</BlockTitle>
                                                                            </BlockHead>
                                                                            <div className="profile-ud-list">
                                                                                <ProfileDetailText label="ID Number" text={page_data?.id_number || "---"} />
                                                                                <ProfileDetailText label="Tpin" text={page_data?.tpin || "---"} />
                                                                            </div>
                                                                        </Block>
                                                                    </>
                                                                )
                                                            }
                                                            {
                                                                activeCardTab === "User Accounts" && (
                                                                    <>
                                                                        <Block>
                                                                            <BlockHead>
                                                                                <BlockTitle tag="h5">User Accounts</BlockTitle>
                                                                                <p>Assigned User Accounts</p>
                                                                            </BlockHead>
                                                                            {/* Table */}
                                                                            <div className="my-3">
                                                                                <ReadOnlyTable data={user_account_list} tableType={type} />
                                                                            </div>
                                                                        </Block>
                                                                    </>
                                                                )
                                                            }
                                                        </div>
                                                        <UserDetailsModal openModal={isUserModelOpen} setOpenModal={setUserModelOpen} type={user_det_modal_type} data={page_data} size="md" successFunction={() => { setUserModelOpen(false); retrieve_user_details(); }} modalTitle="Add User Account" />

                                                        <EditUserMainDetailsModal isOpen={edit_main_details_modal} cloasModal={close_edit_main_details_modal} successFunction={edit_user_details_successfunction} data={page_data} />
                                                    </>
                                            }
                                        </>
                                }
                            </div>
                        </div>
                    </Card>
                </Block>
            </Content>
        </>
    );
};

export default UserDetails;
